import ContractFormView from './ContractFormView';

export default ContractFormView;
